import { init, sso } from '@ad/uc';
import { Env } from '@ad/uc/lib/types';
import axios from 'axios';
import { message } from 'm-ui';
import store from 'store';
import { fetchUserInfo } from 'store/global';
import history from './history';

const switchEnv = (env: string): string => {
  if (env === 'local') return 'test';
  return env;
};

const env = process.env.REACT_APP_STAGE ?? 'production';
const getLoginUrl = () => {
  console.log('env::>>>>>>>', env);
  switch (env) {
    case 'test':
    case 'local':
      return 'https://master--kuaishou-frontend-dsp.jinx.corp.kuaishou.com';
    case 'staging':
      return 'https://chore-staging--kuaishou-frontend-dsp.jinx.staging.kuaishou.com';
    case 'beta':
      return 'https://beta-ad-e.corp.kuaishou.com';
    case 'production':
      return 'https://ad.e.kuaishou.com';
    default:
      return 'https://master--kuaishou-frontend-dsp.jinx.corp.kuaishou.com';
  }
};

const sid: string = 'kuaishou.ad.dsp';
const appKey = 'ad.adUkmConfig.adInavad';

const logoutRedirectUrl = `${getLoginUrl()}/welcome?redirectUrl=${encodeURIComponent(
  window.location.origin,
)}`;

export async function login({ sid }: { sid: string }) {
  try {
    const res = await axios.post<any, any>(`/rest/infra/sts?sid=${sid}`);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
  // 这个不加 basePath
}

const PASS_TOKEN_URL = {
  test: 'https://ksid.test.gifshow.com/pass/kuaishou/login/passToken',
  staging: 'https://ksid-staging.corp.kuaishou.com/pass/kuaishou/login/passToken',
  beta: 'https://id.kuaishou.com/pass/kuaishou/login/passToken',
  production: 'https://id.kuaishou.com/pass/kuaishou/login/passToken',
};

const getLoginState = async () => {
  try {
    if (process.env.REACT_APP_STAGE === 'local') {
      message.info('开发环境不走鉴权');
      return;
    }
    // const { authToken } = await sso.passToken();
    const data = await sso.refreshLoginStatus({
      sid: encodeURIComponent(sid),
      passTokenUrl: PASS_TOKEN_URL[switchEnv(env) as Env],
      stsUrl: `${window.location.origin}/rest/infra/sts`,
    });

    if (data.result === 0) {
      throw new Error('更新登录态失败');
      // window.location.href = `${getLoginUrl()}/welcome?redirectUrl=${encodeURIComponent(
      //   window.location.href,
      // )}`;
      // await login({
      //   sid: encodeURIComponent(sid),
      // });
    }
    store.dispatch(fetchUserInfo());
  } catch (e) {
    // message.info('登录失效，重定向到登录页面');
    window.location.href = `${getLoginUrl()}/welcome?redirectUrl=${encodeURIComponent(
      window.location.href,
    )}`;
  }
};
const uc = init({
  sid,
  env: switchEnv(env) as Env,
  appKey,
  history,
  interceptorAccount: true,
  interceptorUnLogged: {
    loginUrl: `${getLoginUrl()}/welcome?redirectUrl=${encodeURIComponent(window.location.href)}`,
    callback: async (_param, _history) => {
      getLoginState();
      return Promise.resolve();
    },
  },
});

export { uc, sso, getLoginState, logoutRedirectUrl };
